import {Controller} from '@hotwired/stimulus';
import {Crisp} from 'crisp-sdk-web';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    connect() {
        Crisp.configure('2085c7f9-09bd-4e15-b93f-881c5640f648', {
            autoload: false,
            sessionMerge: true,
        });
        Crisp.setSafeMode(true);
        Crisp.setHideOnAway(false);
        Crisp.setAvailabilityTooltip(false);

        if (Object.keys(window.user).length > 0) {
            let sessionData = {
                customer_id: window.user.id,
                account_type: window.user.accountType.name,
                account_type_id: window.user.accountType.id,
                account_type_type: window.user.accountType.type,
                subscription_id: window.user.lastSubscriptionId ? window.user.lastSubscriptionId : 'none',
            };

            Crisp.setTokenId(window.user.token);
            Crisp.user.setEmail(window.user.email);
            Crisp.user.setNickname(window.user.username);
            Crisp.session.setSegments(['logged-in'], true);
            Crisp.session.setData(sessionData);
        } else {
            Crisp.session.setSegments(['logged-out'], true);
        }
        Crisp.chat.show();
    }

    disconnect() {
        if (!Crisp.chat.isChatOpened()) {
            Crisp.session.reset();
            Crisp.chat.hide();
            Crisp.setVacationMode(true);
        }
    }

    open() {
        Crisp.setVacationMode(false);
        if (Crisp.chat.isChatOpened()) {
            Crisp.chat.close();
        } else {
            Crisp.chat.open();
        }
    }
}
